/* ============================================================
   le-sample-select.js — Lab Effects shared "choose a sample" dropdown.

   A compact, searchable, category-grouped selector for sample/outlier
   products that carry many options (Beer & Spirits, water-soluble, …).
   Used by both the PDP buybox (lab-pdp.js) and the collection quick-add
   slide-up (le-quick-add.js) so the experience is identical everywhere.

   window.LE_sampleSelect(mountEl, {
     label,                         // heading text (pulled from the Shopify option name)
     placeholder,                   // button text when nothing chosen
     samples: [{ v, label, group, color }],   // v = raw option value (for cart)
     value,                         // initially-selected raw value
     onChange(rawValue)             // called on selection
   }) -> { setValue, getValue }
   ============================================================ */
(function () {
  if (window.LE_sampleSelect) return;

  var CHEV = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>';
  var SEARCH = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';

  function e(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }

  window.LE_sampleSelect = function (mount, opts) {
    opts = opts || {};
    var samples = opts.samples || [];
    var value = opts.value || null;
    var onChange = opts.onChange || function () {};

    mount.classList.add('le-ss');
    mount.innerHTML = '';
    var open = false;

    var btn = e('button', 'le-ss__btn');
    btn.type = 'button';
    var panel = e('div', 'le-ss__panel');
    panel.hidden = true;

    var searchWrap = e('div', 'le-ss__searchwrap');
    searchWrap.innerHTML = SEARCH;
    var input = e('input', 'le-ss__input');
    input.type = 'text';
    input.placeholder = 'Search…';
    input.setAttribute('aria-label', 'Search options');
    searchWrap.appendChild(input);
    var list = e('div', 'le-ss__list');
    panel.appendChild(searchWrap);
    panel.appendChild(list);
    mount.appendChild(btn);
    mount.appendChild(panel);

    // Build grouped list (groups in first-appearance order). A blank group ('')
    // means "no category" (kits, TTB flavor enhancements) → flat, header-less list.
    var rows = [], groupOrder = [], groups = {};
    samples.forEach(function (s) {
      var g = s.group || '';
      if (!(g in groups)) { groups[g] = { color: s.color, hdr: null }; groupOrder.push(g); }
    });
    // Headers only when there's more than one *named* group (powders/liquids).
    var namedGroups = groupOrder.filter(function (g) { return g !== ''; });
    var showHeaders = namedGroups.length > 1;
    groupOrder.forEach(function (g) {
      if (showHeaders && g !== '') {
        var hdr = e('div', 'le-ss__group');
        var dot = e('span', 'le-ss__dot'); dot.style.background = groups[g].color || '#108090';
        hdr.appendChild(dot);
        hdr.appendChild(document.createTextNode(g));
        list.appendChild(hdr);
        groups[g].hdr = hdr;
      }
      samples.filter(function (s) { return (s.group || '') === g; }).forEach(function (s) {
        var opt = e('button', 'le-ss__opt');
        opt.type = 'button';
        opt.style.setProperty('--ss-color', s.color || '#108090');
        var lab = e('span'); lab.textContent = s.label;
        var ck = e('span', 'le-ss__check'); ck.innerHTML = CHECK;
        opt.appendChild(lab); opt.appendChild(ck);
        opt.addEventListener('click', function () { select(s.v); });
        list.appendChild(opt);
        rows.push({ row: opt, group: g, value: s.v, label: s.label, color: s.color, search: (s.label + ' ' + g).toLowerCase() });
      });
    });

    function renderBtn() {
      var cur = rows.filter(function (r) { return r.value === value; })[0];
      btn.innerHTML = '';
      var left = e('span', 'le-ss__cur');
      if (cur) {
        // Dot + group label only when the option carries a real category.
        if (cur.group) {
          var dot = e('span', 'le-ss__dot'); dot.style.background = cur.color || '#108090';
          left.appendChild(dot);
        }
        var lab = e('span', 'le-ss__curlabel'); lab.textContent = cur.label;
        left.appendChild(lab);
        if (cur.group) {
          var grp = e('span', 'le-ss__curgroup'); grp.textContent = cur.group;
          left.appendChild(grp);
        }
      } else {
        var ph = e('span', 'le-ss__ph'); ph.textContent = opts.placeholder || 'Select an option';
        left.appendChild(ph);
      }
      var chev = e('span', 'le-ss__chev'); chev.innerHTML = CHEV;
      btn.appendChild(left); btn.appendChild(chev);
      rows.forEach(function (r) { r.row.classList.toggle('le-ss__opt--active', r.value === value); });
    }

    function setOpen(o) {
      open = o;
      panel.hidden = !o;
      mount.classList.toggle('le-ss--open', o);
      /* DECIDE THE DIRECTION FROM THE SPACE THAT EXISTS.

         Inside a bottom slide-up the trigger sits low, so a downward panel ran
         off the bottom of the sheet — the shopper had to scroll a list they
         could not see the end of, and might not know was there. Measured
         before the panel paints: if what is below the trigger cannot hold the
         panel and there is more room above, open upward.

         `panelH` is the CSS max-height (264px list + ~44px search row) rather
         than a live measurement, because the panel has not been laid out yet
         at this point and measuring it would force a reflow every open. */
      if (o) {
        var r = btn.getBoundingClientRect();
        var panelH = 308;
        var below = window.innerHeight - r.bottom;
        var above = r.top;
        mount.classList.toggle('le-ss--up', below < panelH && above > below);
      } else {
        mount.classList.remove('le-ss--up');
      }
      if (o) {
        input.value = ''; filter('');
        /* FOCUS THE SEARCH BOX ON POINTER DEVICES ONLY.

           Focusing it opens the on-screen keyboard the instant the dropdown
           opens, which on Android covers most of the list the shopper just
           asked to see — they have to dismiss the keyboard before they can
           choose. On a mouse or trackpad there is no keyboard to summon and
           type-to-filter is the fast path, so it stays.

           `(hover: hover) and (pointer: fine)` is the capability test, not a
           width test: a small window on a laptop still gets the focus, and a
           large Android tablet still does not. */
        var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (fine) setTimeout(function () { try { input.focus(); } catch (e) {} }, 30);
      }
    }
    function select(v) { value = v; renderBtn(); setOpen(false); onChange(v); }

    function filter(q) {
      q = (q || '').toLowerCase().trim();
      var anyByGroup = {};
      rows.forEach(function (r) {
        var show = !q || r.search.indexOf(q) !== -1;
        r.row.hidden = !show;
        if (show) anyByGroup[r.group] = true;
      });
      groupOrder.forEach(function (g) { if (groups[g].hdr) groups[g].hdr.hidden = !anyByGroup[g]; });
    }

    btn.addEventListener('click', function (ev) { ev.stopPropagation(); ev.preventDefault(); setOpen(!open); });
    input.addEventListener('input', function () { filter(input.value); });
    input.addEventListener('click', function (ev) { ev.stopPropagation(); });
    document.addEventListener('click', function (ev) { if (open && !mount.contains(ev.target)) setOpen(false); });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && open) setOpen(false); });

    renderBtn();
    return {
      setValue: function (v) { value = v; renderBtn(); },
      getValue: function () { return value; }
    };
  };
})();
